<!-- Ported from the Polaris kit: src/components/ui/table/TableCaption.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <caption
    data-slot="table-caption"
    :class="
      cn('text-polaris-muted-foreground mt-4 type-polaris-body', props.class)
    "
  >
    <slot />
  </caption>
</template>
